/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { AutosaveParameters } from './AutosaveParameters';
import type { VehicleMarketplaceParameters } from './VehicleMarketplaceParameters';
import type { Banners } from './Banners';
import type { LeadHomeScreenParameters } from './LeadHomeScreenParameters';
import type { InfobipLiveChatParameters } from './InfobipLiveChatParameters';

export interface GetSignupProcessFeaturesResponse {
    autosave: AutosaveParameters;
    banners: Banners;
    vehicle_marketplace: VehicleMarketplaceParameters;
    lead_home_screen: LeadHomeScreenParameters;
    infobip_live_chat: InfobipLiveChatParameters;
}
